import { BaseEntity, DefaultResponseWithData } from "./system";
import { PartStatus } from "./Part";

export interface IWorkOrdersResponse extends DefaultResponseWithData<IWorkOrder[]> { }
export interface ISingleWorkOrderResponse extends DefaultResponseWithData<IWorkOrder> { }

export interface IWorkOrder extends BaseEntity {
    orderNumber: string;
    title: string;
    notes: string;
    assigneeId: string | null;
    createdById: string | null;
    priority: WorkOrderPriority;
    status: WorkOrderStatus;
    dueDate: string | null;
    reminderDate: string | null;
    workOrderItems: IWorkOrderItem[];
}

export interface IWorkOrderItem extends BaseEntity {
    workOrderId: string;
    type: WorkOrderItemType;
    title: string;
    linkedId: string;
    rejectionStatus: WorkOrderItemRejectionStatus;
}

export interface ICreateWorkOrderItemRequest {
    type: WorkOrderItemType;
    title: string;
    linkedId: string;
}

export enum WorkOrderItemRejectionStatus {
    None,
    QC,
    Scrapped
}

export interface IWorkOrderPart {
    workOrderItemId: string;
    linkedId: string;
    type: WorkOrderItemType;
    title: string;
    tagNumber: string | null;
    partCategoryName: string | null;
    accountName: string | null;
    warehouseLocation: string | null;
    price: number | null;
    partStatus: PartStatus | null;
    rejectionStatus: WorkOrderItemRejectionStatus;
    rejectionReason: string | null;
    /** Make/model/year of the donor car, populated for stock items. */
    donorVehicleDescription: string | null;
    vrm: string | null;
    vin: string | null;
}

export interface IWorkOrderPartsResponse extends DefaultResponseWithData<IWorkOrderPart[]> { }

export interface IUpdateWorkOrderItemRejectionRequest {
    rejectionStatus: WorkOrderItemRejectionStatus;
    reason: string | null;
}

export interface IUpdateWorkOrderItemPriceRequest {
    price: number | null;
}

export interface ICreateWorkOrderRequest {
    title: string;
    notes: string;
    assigneeId: string | null;
    createdById: string | null;
    priority: WorkOrderPriority;
    status: WorkOrderStatus;
    dueDate: string | null;
    reminderDate: string | null;
    items: ICreateWorkOrderItemRequest[];
}

export interface IUpdateWorkOrderStatusRequest {
    status: WorkOrderStatus;
}

export enum WorkOrderPriority {
    Low,
    Medium,
    High,
    Critical
}

export enum WorkOrderStatus {
    ToDo,
    InProgress,
    Complete
}

// NOTE: These values are sent over the wire as ints and persisted as ints.
// They MUST stay in sync with the backend enum in GPMetals.Core/Entities/WorkOrderItem.cs.
export enum WorkOrderItemType {
    Vehicle,
    Stock,
    Lead,
    Order,
    User
}


export interface IWorkOrderStats {
    total: number;
    toDo: number;
    inProgress: number;
    complete: number;
}

export interface IWorkOrderStatsResponse extends DefaultResponseWithData<IWorkOrderStats> { }